<ng-content select="ux-select-header-user" (click)="toggle()"></ng-content>
@if (isOpen) {
  <div (clickOutside)="close()" [delayClickOutsideInit]="true">
    <ng-content select="[items]"></ng-content>
  </div>
}
